import React from "react";

import Layout from "./src/layouts/index";



export function wrapPageElement({ element, props }) {
    return <Layout {...props}>{element}</Layout>;
}